"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleSearchResultsAction = toggleSearchResultsAction;
exports.toggleIncludeMnoAction = toggleIncludeMnoAction;
exports.setFilterOptionsState = setFilterOptionsState;
function toggleSearchResultsAction() {
    return {
        type: "mlc-usage-statistics/TOGGLE_SEARCH_RESULTS"
    };
}
function toggleIncludeMnoAction() {
    return {
        type: "mlc-usage-statistics/TOGGLE_INCLUDE_MNO"
    };
}
function setFilterOptionsState(filterOptionsState) {
    return {
        type: "mlc-usage-statistics/SET_FILTER_OPTIONS_STATE",
        filterOptionsState
    };
}
//# sourceMappingURL=actions.js.map